import React, { useCallback, useEffect, useRef, useState } from "react";

import { Box, Flex, Image, Text } from "atoms";
import { TOPBAR_HEIGHT } from "utilities/constants";
import ProfileAvatar from "molecules/ProfileAvatar";
import ProfileIcon from "assets/img/profile.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "contexts/Auth";

export const DashboardHeader = () => {
  const {
    state: { userData },
  } = useAuth();

  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

  // open and close state of user dropdown
  const handleUserDropdownState = useCallback(() => {
    setIsUserDropdownOpen((currentState) => !currentState);
  }, []);

  useEffect(() => {
    /**
     * Invoke Function onClick outside of element
     */
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsUserDropdownOpen(false);
      }
    }
    // Bind
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // dispose
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <Flex
      bg="white"
      as="header"
      aI="center"
      h={TOPBAR_HEIGHT}
      w="100%"
      jC="space-between"
      bR="8px"
      px="2.4rem"
      py="1.2rem"
    >
      <Flex aI="center"></Flex>

      {/* profile */}
      <Box ml="2.4rem" cursor="pointer" onClick={handleUserDropdownState}>
        <ProfileAvatar name={userData?.name || ""} />
        {/* profile click card */}
        <Box
          as="span"
          minWidth="16rem"
          position="absolute"
          bg="white"
          right="-15%"
          top="140%"
          bR="1rem"
          boxShadow="m"
          ref={dropdownRef}
          {...(!isUserDropdownOpen && { display: "none" })}
          zIndex="100"
          width="20rem"
        >
          <Box px="2.8rem" py="2.6rem">
            {/* user details */}
            <Flex
              pb="1.5rem"
              alignitems="center"
              cursor="pointer"
              onClick={() => navigate("/setting/profile")}
            >
              <Image src={ProfileIcon} alt="profile" height="2rem" />
              <Text color="primary.900" fontFamily="NeometricRegular" ml="1rem">
                My Profile
              </Text>
            </Flex>
            {/* line */}
            <Box h="0.5px" border="0.5px dashed" borderColor="neutral.100" />

            <Box cursor="pointer">
              <Box pt="1.5rem" onClick={() => navigate("/logout")}>
                <Text color="secondary.700" fontFamily="NeometricExtraBold">
                  Log Out
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};
